import { useCallback, useEffect, useRef } from 'react';
import { useBoolean } from '../../../../utils/hooks/useBoolean';
import { MediaManagerSDKAnyItem } from '../../../../utils/media-manager-sdk';

const SCROLL_AMOUNT = 500;

const enum ScrollDirections {
  Right = 1,
  Left = -1,
}

const scrollWrapper = (element, direction) => (element.scrollLeft = element.scrollLeft + direction * SCROLL_AMOUNT);

const isOnScrollStart = (scrollingWrapper) => scrollingWrapper.scrollLeft === 0;

const isOnScrollEnd = (scrollingWrapper) =>
  scrollingWrapper.scrollLeft + scrollingWrapper.offsetWidth === scrollingWrapper.scrollWidth;

const scrollToStart = (scrollingWrapper) => {
  scrollingWrapper.scrollLeft = 0;
};

const emptyItems = [];

export const useHomeSliderControl = (items: MediaManagerSDKAnyItem[] = emptyItems) => {
  const scrollingWrapper = useRef(null);

  useEffect(() => {
    const onScroll = (event) => {
      const delta = event.deltaX || event.wheelDeltaX;

      if (
        (isOnScrollEnd(scrollingWrapper.current) && delta > 0) ||
        (isOnScrollStart(scrollingWrapper.current) && delta < 0)
      ) {
        event.preventDefault();
      }
    };

    if (!scrollingWrapper.current) {
      return;
    }

    scrollingWrapper.current.addEventListener('wheel', onScroll, false);

    return () => scrollingWrapper.current.removeEventListener('wheel', onScroll, false);
  }, []);

  useEffect(() => {
    if (!scrollingWrapper.current) {
      return;
    }

    scrollToStart(scrollingWrapper.current);
  }, [items.length]);

  const onScrollLeft = useCallback(() => scrollWrapper(scrollingWrapper.current, ScrollDirections.Left), []);
  const onScrollRight = useCallback(() => scrollWrapper(scrollingWrapper.current, ScrollDirections.Right), []);

  const { value: showRightArrow, setFalse: onScrollEdgeRight, setTrue: onScrollMiddleRight } = useBoolean(true);
  const { value: showLeftArrow, setFalse: onScrollEdgeLeft, setTrue: onScrollMiddleLeft } = useBoolean();

  const onScrollWrapper = useCallback(() => {
    if (!scrollingWrapper.current) {
      return;
    }

    if (isOnScrollStart(scrollingWrapper.current)) {
      onScrollEdgeLeft();
    }

    if (isOnScrollEnd(scrollingWrapper.current)) {
      onScrollEdgeRight();
    }

    if (!isOnScrollStart(scrollingWrapper.current) && !isOnScrollEnd(scrollingWrapper.current)) {
      onScrollMiddleLeft();
      onScrollMiddleRight();
    }
  }, []);

  return {
    onScrollLeft,
    onScrollRight,
    showRightArrow,
    showLeftArrow,
    onScrollWrapper,
    scrollingWrapper,
  };
};
